import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  getReviewsByTeacherId,
  updateReviewById,
  deleteReview,
} from '../../../actions/review'
import {
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material'
import ReviewItem from './ReviewItem'
import { useTheme } from '@mui/styles'

const Reviews = ({
  teacherId,
  getReviewsByTeacherId,
  updateReviewById,
  auth: { user },
  review: { reviews, loading, error },
  deleteReview,
  isTeacher
}) => {
  const theme = useTheme()
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))

  useEffect(() => {
    getReviewsByTeacherId(teacherId)
  }, [getReviewsByTeacherId, teacherId])

  return (
    <Card>
      <CardContent>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={3}
        >
          <Grid item>
            <Typography style={{ textAlign: 'center' }} variant="h6">
              Những nhận xét về giáo viên:
            </Typography>
          </Grid>

          <Grid
            item
            container
            justifyContent={matchesLG ? 'space-around' : 'center'}
            alignItems="center"
            spacing={2}
          >
            {reviews.length === 0 ? (
              <Typography variant="body1">
                Chưa có nhận xét nào về giáo viên.
              </Typography>
            ) : (
              reviews.map((review) => (
                <Grid
                  item
                  key={review._id}
                  style={{
                    border: '2px solid #3b3b3b',
                    borderRadius: '4px',
                    margin: '5px',
                    padding: '1em',
                    minWidth: '20em'
                  }}
                  lg={5}
                >
                  <ReviewItem
                    review={review}
                    updateReviewById={updateReviewById}
                    deleteReview={deleteReview}
                    user={user}
                  />
                </Grid>
              ))
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  review: state.review,
})

export default connect(mapStateToProps, {
  getReviewsByTeacherId,
  updateReviewById,
  deleteReview,
})(Reviews)
